import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-music-note",
  "use": "icon-s-music-note-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-music-note\"><path d=\"M10 0h2c0 2.5 1.5 4 3.8 5.4C18.6 7.1 20 9 20 11.5c0 1.3-.4 2.5-1 3.5 0-2.5-2.2-4.6-7-5.3v8.8h-2ZM2 18.5a5 3.5 0 1 1 10 0 5 3.5 0 1 1-10 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol